module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Back",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,24 L0,0 L6,0 L6,2 L2.08571429,2 L2.08571429,22 L6,22 L6,24 L0,24 Z M23,18 L13,13 L13,11 L23,6 L23,8 L15,12.0218182 L23,16 L23,18 Z M30,24 L36,24 L36,0 L30,0 L30,2 L34,2 L34,22 L30,22 L30,24 Z",
      "id": "[+]"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b2b13f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/prev.vue
// module id = 612
// module chunks = 1